import { useEffect, useRef } from "react";

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const scrollY = window.scrollY;
        heroRef.current.style.transform = `translateY(${scrollY * 0.4}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#050810]">
      {/* Background gradient */}
      <div ref={heroRef} className="absolute inset-0 will-change-transform">
        <div className="w-full h-full bg-gradient-to-br from-[#050810] via-[#0a0e1f] to-[#050810]"></div>
        <div className="absolute top-1/4 left-1/3 w-[600px] h-[600px] rounded-full bg-[#d4af37]/6 blur-[120px]"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full bg-[#1a2a5e]/30 blur-[100px]"></div>
      </div>

      {/* Animated grid overlay */}
      <div className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "linear-gradient(rgba(212,175,55,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.3) 1px, transparent 1px)",
          backgroundSize: "80px 80px"
        }}
      ></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#d4af37] animate-pulse"></span>
            <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase">Premium Web Agency</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[1.05] mb-6 tracking-tight">
            We Build Websites<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">
              That Get You Clients
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-white/60 max-w-xl leading-relaxed mb-10">
            Modern, high-performance websites designed to turn visitors into customers. Built for results, not just looks.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="#contact"
              className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#d4af37] text-[#050810] font-bold text-sm tracking-wide hover:bg-[#e8c84a] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Your Free Consultation
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[#050810] group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-line text-[#d4af37] text-sm"></i>
              </span>
            </a>

          </div>


        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/30"></i>
      </div>
    </section>
  );
}
